/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Section_NotificationsInputs */

const en_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const es_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const fr_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const de_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

const ja_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const zh_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const ar_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات`)
};

const id_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi`)
};

const it_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche`)
};

const ru_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления`)
};

const pt_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const ko_settings_section_notifications = /** @type {(inputs: Settings_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Settings_Section_NotificationsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_section_notifications = /** @type {((inputs?: Settings_Section_NotificationsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Section_NotificationsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_section_notifications(inputs)
	if (locale === "es") return es_settings_section_notifications(inputs)
	if (locale === "fr") return fr_settings_section_notifications(inputs)
	if (locale === "de") return de_settings_section_notifications(inputs)
	if (locale === "ja") return ja_settings_section_notifications(inputs)
	if (locale === "zh") return zh_settings_section_notifications(inputs)
	if (locale === "ar") return ar_settings_section_notifications(inputs)
	if (locale === "id") return id_settings_section_notifications(inputs)
	if (locale === "it") return it_settings_section_notifications(inputs)
	if (locale === "ru") return ru_settings_section_notifications(inputs)
	if (locale === "pt") return pt_settings_section_notifications(inputs)
	return ko_settings_section_notifications(inputs)
});